/**
 * @file page entry
 * @author liuweijian01
 */
import 'babel-polyfill';
import Vue from 'vue';
import preview from 'vue-photo-preview';
import VueClipboard from 'vue-clipboard2';
import VueLazyload from 'vue-lazyload';
import 'vue-photo-preview/dist/skin.css';
import Loading from '@/directives/loading.js';
import App from './app.vue';
import {performanceMonitor} from '@/utils/browser';
import logger from '@/plugins/logger';
import {getUserAgentInfo} from '@/utils/browser-info';
import {getFormatCookie} from '@/utils/experiment';
import {getQueryString} from '@/utils/url';
import {SPECIAL_CHANNEL_MAP} from '@/common/js/Constant';
import Toast from '@/directives/toast.js';
import NumberFilter from '@/plugins/numberFilter';
import VueCompositionAPI from '@vue/composition-api';
import smoothscroll from 'smoothscroll-polyfill';
import api from '@/api';
import {generateToken} from '@/utils/tiebaUtility';
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import scroll from 'vue-seamless-scroll';
smoothscroll.polyfill();
const formatCookie = getFormatCookie();
import initWeirwood from '@/utils/weirwood';
import * as echarts from 'echarts';
window.isSendWiseEndCount = false;
window.onload = function () {
    if (!window.isSendWiseEndCount) {
        performanceMonitor('13_96', 'gamepage_zone');
        window.isSendWiseEndCount = true;
    }
};

window.detailUserAgentInfo = getUserAgentInfo();

let effectiveType = '';
if (navigator && navigator.connection && navigator.connection.effectiveType) {
    effectiveType = navigator.connection.effectiveType;
}
let loggerBody = {
    from: 'Mini_Swan_game',
    page: 'newDetailPage',
    inBox: '0',
    network: effectiveType,
    styleInfo: formatCookie.GAME_SID_KEY || '',
    source: getQueryString('channelid') || '',
};
Vue.use(VueLazyload);

Vue.use(preview, {
    tapToClose: true,
    fullscreenEl: false,
});

Vue.use(Loading);
Vue.use(VueClipboard);
Vue.use(NumberFilter);
Vue.use(scroll);
// window.getNetworkTypeFromBdBox = jsonData => {
//     const data = JSON.parse(jsonData);
//     if (data && data.status === '0' && data.data && data.data.networkType === 'wifi') {
//         Vue.prototype.$wifi = true;
//     }
// };
try {
    Vue.prototype.$wifi = (window.navigator.connection.effectiveType === 'wifi');
}
catch {
    Vue.prototype.$wifi = false;
}



export const eventBus = new Vue();

Vue.use(logger, loggerBody);
Vue.use(Toast);
initWeirwood(Vue); // 初始化weirwood
Vue.use(VueCompositionAPI);
Vue.config.productionTip = false;
document.title = '百度游戏';
Vue.prototype. $echarts = echarts;

new Vue({
    data() {
        return {
            tabIndex: 0,
            tabs: [],
            videoView: [],
            extData: {},
            officialJoinedStyle: false,
            officialBigImg: '',
            officialJoinedColors: {},
            bkAnchor: '-1',
            isSuperProduct: false,
            isPreDownload: false,
            isShowTopBtn: false,
            isShowTbFloatPanel: true,
            isFromTiebaFeed: +getQueryString('channelid') === SPECIAL_CHANNEL_MAP.TIEBA_FEED,
            DOWNLOAD_ACTIONS: {
                DOWNLOAD: 1,
                JUMP: 2,
                IOS_DOWNLOAD: 3,
                NUKNOW: 11, // PC未知
                OFFICIAL_FREE: 12, // PC官方免费
                UNOFFICIAL_FREE: 13, // PC非官方免费
                OFFICIAL_PAY: 14, // PC官方付费
                UNOFFICIAL_PAY: 15, // PC非官方付费
            },
            DATA_SOURCE: {
                LIANYUN: 'lianyun', // 联运包
                BUSINESS: 'business', // 商业包
                OFFICIAL: 'official', // 官方入驻包
                OTHER: 'other', // 其他下载包
                THIRD: 'third', // 第三方链接，仅限pc
                CHANNEL: 'channel', // 购买渠道，仅限pc
            },
            APPOINTMENT_ACTIONS: {
                JUMP: 15,
            },
            videoUrl: '',
            isRecommendSelected: false, // 推荐下载被选中
            middlePage: 'https://tieba.baidu.com/mo/q/wise-grow-operate/downloadMidPage?bgImg=newdefault&wakeupConf=38&autoClick=0&isDown=0&isAppstore=0&downInfo=38&source=38', // 贴吧下载中间页
            isTieBaApp: false, // 是否在贴吧app内
            showShopDrawer: false,
            isShowFourElements: 0,
            isShowRcDownloadDrawer: false,
            isShowVipPanel: false,
            currentSkuId: '',
            productType: 0,
            currentSkuInfo: {},
            isAppointmentGame: false,
            isHarmonyOS: false,
        };
    },
    computed: {
        officialNormalFontColor() {
            return this.officialJoinedStyle ? '#FFF' : '';
        },
        officialHighLightFontColor() {
            return this.officialJoinedStyle ? this.officialJoinedColors.font : '';
        },
        officialHighLightBtnColor() {
            return this.officialJoinedStyle ? this.officialJoinedColors.button : '';
        },
        officialBackgroundColor() {
            return this.officialJoinedStyle ? this.officialJoinedColors.background : '';
        },
    },
    methods: {
        sendLog(type, value, ext = {}) {
            this.$logger.shortcut(type, {value}, {
                ...this.extData,
                ...ext,
            });
        },
        report(token) {
            const {device, os} = window.tbLibPlugin.parse();
            const params = {
                data: {
                    cuid: '',
                    channelid: getQueryString('channelid') || '',
                    token,
                    device,
                    os,
                },
            };
            return api.zone.reportTbParams(params);
        },
        // 获取token
        getToken(url) {
            const config = {
                page: 'tbwebview',
                param: {
                    obj_source: 'wise',
                    locate: 'outer_game_mfl',
                    track: 'test',
                    url,
                },
            };
            return generateToken(config);
        },
        // 调起贴吧App
        wakeUpTiebaApp(token, pageUrl, pkgUrl) {
            TiebaNewWakeUp.init({
                page: 'tbwebview',
                param: {
                    obj_source: 'wise',
                    locate: 'outer_game_mfl',
                    token: token,
                    url: encodeURIComponent(pageUrl),
                },
                androidDownUrl: pkgUrl,
                androidShoubaiGoCenterPage: false,
                middlePageBrowsers: [],
            });
        },
    },
    render: h => h(App),
}).$mount('#app');
